export default "__VITE_ASSET__Bfwk0fp7__"